import Vue from 'vue'
import Router from 'vue-router'

// Containers
import * as Container from '@/containers'

// Views
import Dashboard_Main from '@/views/Dashboard/Dashboard_Main.i18n'
import Dashboard_Main_Sales from '@/views/Dashboard/Dashboard_Main_Sales.i18n'
import Dashboard_WMDS from '@/views/Dashboard/Dashboard_WMDS.i18n'
import Dashboard_WSFinder from '@/views/Dashboard/Dashboard_WSFinder.i18n'
import Dashboard_WebCastle from '@/views/Dashboard/Dashboard_WebCastle.i18n'

import * as Views from '@/views'
import * as WMDS from '@/views/WMDS'
import * as WSFinder from '@/views/WSFinder'
import * as WebCastle from '@/views/WebCastle'
// import * as History from '@/views/History'
// import * as Log from '@/views/WebCastle'

Vue.use(Router)
console.info(Views.Setting.Setting_SMTP)
export default new Router({
  mode: 'hash', // hash or
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/', redirect: '/dashboard', name: '/', meta: { label: 'Main', requiresAuth : true }, component: Container.Private,
      children: [
        { path: 'dashboard', name: 'dashboard', meta: { label: 'Dashboard'}, component: Dashboard_Main },
        { path: 'dashboard_sales', name: 'dashboard', meta: { label: 'Dashboard'}, component: Dashboard_Main_Sales },
      ]
    },
    { path: '/management', redirect: '/management/signup', name: 'management', meta: { label: 'Management', requiresAuth : true }, component: Container.Private,
      children: [
        { path: 'signup/:id?/:tag?', name: 'signup', meta: { label: 'Signup'}, component: Views.Signup.Base },
        { path: 'signout/:id?/:tag?', name: 'signout', meta: { label: 'Signout'}, component: Views.Signout.Base },
        { path: 'user/:id?/:tag?', name: 'user', meta: { label: 'User'}, component: Views.User.Base },
        { path: 'admin/:id?/:tag?', name: 'admin', meta: { label: 'Admin'}, component: Views.Admin.Base },
        { path: 'partner/:id?/:tag?', name: 'partner', meta: { label: 'Partner'}, component: Views.Partner.Base },
        { path: 'group/:id?/:tag?', name: 'group', meta: { label: 'Group'}, component: Views.Group.Base },
        { path: 'profile/:tag?', name: 'profile', meta: { label: 'Profile' }, component: Views.Profile.Base },
      ]
    },
    { path: '/billing', redirect: '/billing/payment', name: 'billing', meta: { label: 'System', requiresAuth : true }, component: Container.Private,
      children: [
        { path: 'payment/:id?/:tag?', name: 'payment', meta: { label: 'Payment' }, component: Views.Payment.Base },
        { path: 'invoice_partner/:id?/:tag?/:invoice_id?', name: 'InvoicePartner', meta: { label: 'Invoice Partner' }, component: Views.InvoicePartner.Base },
        { path: 'invoice_group/:id?/:tag?/:invoice_id?', name: 'InvoiceGroup', meta: { label: 'Invoice Group' }, component: Views.InvoiceGroup.Base },
      ]
    },
    { path: '/system', redirect: '/setting', name: 'system', meta: { label: 'System', requiresAuth : true }, component: Container.Private,
      children: [
        { path: 'setting/:tag?', name: 'setting', meta: { label: 'Setting' }, component: Views.Setting.Base },
        { path: 'mail/:id?/:tag?', name: 'mail', meta: { label: 'Mail' }, component: Views.Mail.Base },
      ]
    },
    { path: '/history', redirect: '/history/payment', name: 'history', meta: { label: 'History', requiresAuth : true }, component: Container.Private,
      children: [

        { path: 'credit/:id?/:tag?', name: 'credit', meta: { label: 'Credit' }, component: Views.Credit.Base },
        { path: 'install/:id?/:tag?', name: 'install', meta: { label: 'Install' }, component: Views.Install .Base },
      ]
    },
    {
      path: '/wmds', redirect: '/wmds/dashboard', name: 'WMDS', component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
        { path: 'dashboard', name: 'wmds_dashboard', meta: { label: 'Dashboard' }, component: Dashboard_WMDS },
        { path: 'site/:id?/:tag?', name: 'wmds_site', meta: { label: 'Site' }, component: WMDS.Site.Base },
        { path: 'detect/:id?/:tag?', name: 'wmds_detect', meta: { label: 'Detect' }, component: WMDS.Detect.Base },
        { path: 'spattern/:id?/:tag?', name: 'wmds_spattern', meta: { label: 'S.Pattern' }, component: WMDS.SystemPattern.Base },
        { path: 'upattern/:id?/:tag?', name: 'wmds_upattern', meta: { label: 'U.Pattern' }, component: WMDS.UserPattern.Base },
        { path: 'result/:id?/:tag?', name: 'wmds_result', meta: { label: 'Result' }, component: WMDS.Result_new.Base },
        { path: 'report/:id?/:tag?', name: 'wmds_report', meta: { label: 'Report' }, component: WMDS.Report.Base },
        { path: 'policy/:id?/:tag?', name: 'wmds_policy', meta: { label: 'Policy' }, component: WMDS.Policy.Base },
        { path: 'schedule/:id?/:tag?', name: 'wmds_schedule', meta: { label: 'Schedule' }, component: WMDS.Schedule.Base },
      ]
    },
    {
      path: '/wsfinder', redirect: '/wsfinder/dashboard', name: 'WSFinder', meta: { label : 'Main', requiresAuth : true }, component: Container.Private,
      children: [
        { path: 'dashboard', name: 'wsfinder_dashboard', meta: { label: 'Dashboard' }, component: Dashboard_WSFinder },
        { path: 'agent/:id?/:tag?', name: 'wsfinder_agent', meta: { label: 'Agent' }, component: WSFinder.Agent.Base },
        { path: 'detect/:id?/:tag?', name: 'wsfinder_detect', meta: { label: 'Detect' }, component: WSFinder.Detect.Base },
        { path: 'result/:id?/:tag?', name: 'wsfinder_result', meta: { label: 'Result' }, component: WSFinder.Result.Base },
        { path: 'spattern/:id?/:tag?', name: 'wsfinder_spattern', meta: { label: 'System Pattern' }, component: WSFinder.SystemPattern.Base },
        { path: 'upattern/:id?/:tag?', name: 'wsfinder_upattern', meta: { label: 'User Pattern' }, component: WSFinder.UserPattern.Base },
        { path: 'hash/:id?/:tag?', name: 'wsfinder_hash', meta: { label: 'Hash' }, component: WSFinder.Hash.Base },
        { path: 'submitted/:id?/:tag?', name: 'wsfinder_submitted', meta: { label: 'Submitted' }, component: WSFinder.Report.Base },
        // { path: 'summary/:id?/:tag?', name: 'wsfinder_summary', meta: { label: 'Summary' }, component: WSFinder.Summary.Base },
        { path: 'webshell/:id?/:tag?', name: 'wsfinder_webshell', meta: { label: 'WebShell' }, component: WSFinder.Webshell.Base },
        { path: 'regist/:id?/:tag?', name: 'wsfinder_regist', meta: { label: 'Regist' }, component: WSFinder.Regist.Base },
      ]
    },
    {
      path: '/webcastle', redirect: '/webcastle/dashboard', name: 'WebCastle', component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
        { path: 'dashboard', name: 'webcastle_dashboard', meta: { label: 'Dashboard' }, component: Dashboard_WebCastle },
        { path: 'modules/:version?/:id?/:tag?', name: 'webcastle_modules', meta: { label: 'Modules' }, component: WebCastle.Modules.Base },
        // { path: 'modules/:id?/:tag?', name: 'webcastle_modules', meta: { label: 'Modules' }, component: WebCastle.Modules.Base },
        { path: 'log/:id?/:tag?', name: 'webcastle_log', meta: { label: 'Log' }, component: WebCastle.Log.Base },
        { path: 'policy/:id?/:tag?', name: 'webcastle_policy', meta: { label: 'Policy' }, component: WebCastle.Policy.Base },
      ]
    },
    {
      path: '/board', redirect: '/board/main', name: 'Board', component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
          { path: 'main/:id?/:tag?', name: 'board_main', meta: { label: 'Main' }, component: Views.MainBoard.Base },
          { path: 'notice/:id?/:tag?', name: 'board_notice', meta: { label: 'Notice' }, component: Views.Notice.Base },
          { path: 'faq/:id?/:tag?', name: 'board_faq', meta: { label: 'FAQ' }, component: Views.FAQ.Base },
          { path: 'qna/:id?/:tag?', name: 'board_qna', meta: { label: 'Q & A' }, component: Views.QNA.Base },
          { path: 'notice_test/:id?/:tag?', name: 'notice_test', meta: { label: 'Notice_Test' }, component: Views.Auth.Notice_Test },
      ]
    },
    {
      path: '/integrity', redirect: '/integrity/main', name: 'WFDetector', component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
        { path: 'main', name: 'integrity_main', meta: { label: 'Main' }, component: Views.Integrity.Main },
        { path: 'detect/:id?/:tag?', name: 'integrity_detect', meta: { label: 'detect' }, component: Views.Integrity.Result },
      ]
    },

    {
      path: '/log', redirect: '/Log/main', name: 'Log', component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
        // { path: 'main', name: 'Log_main', meta: { label: 'Log' }, component: Views.Integrity.Main },
        { path: 'login/:id?/:tag?', name: 'log_login', meta: { label: 'login' }, component: Views.LogLogin.Base },
        { path: 'action/:id?/:tag?', name: 'log_action', meta: { label: 'action' }, component: Views.LogAction.Base },
        { path: 'auth/:id?/:tag?', name: 'log_auth', meta: { label: 'auth' }, component: Views.LogAuth.Base },
        { path: 'mail/:id?/:tag?', name: 'log_mail', meta: { label: 'mail' }, component: Views.LogMail.Base },
        { path: 'system/:id?/:tag?', name: 'log_system', meta: { label: 'system' }, component: Views.LogSystem.Base },
      ]
    },

    {
      path: '/auth', name: 'auth_main', component: { render(c) { return c('router-view'); } },
      children: [
        { path: 'login', name: 'auth_login', component: Views.Auth.Login },
      ]
    },

    {
      path: '/', name: 'auth_main', component: { render(c) { return c('router-view'); } },
      children: [
        { path: 'reset', name: 'auth_reset', component: Views.Auth.Reset, props: (route) => ({ token : route.query.token, username : route.query.username })},
      ]
    },

    { path: '*', redirect: '/auth/login' }
  ]
});
